// モバイルアプリからページを読み込む際のリンクにパラメータapp=trueを設定しておく
// モバイルアプリからのアクセスを判別しcssをHTMLに出力する

// クッキーリセット
//document.cookie = 'app=; max-age=0';

// パラメーターappの値を変数valueに格納
var params = (new URL(document.location)).searchParams;
var value = params.get('app');

// cookieに"app=value"をセット、有効期限を1日に設定
if (value) {
  document.cookie = 'app=' + value + '; max-age=60*60*24*1';
}

// cookieに"app=true存在するならrax-for-app.css?v=nをhtmlで読み込ませる（cssを変えたらv=nの数字を増やす）
var cookies = document.cookie;
if (cookies) {
  var cookie = cookies.split("; ");
  for (let i = 0; i < cookie.length; i++) {
    var key_value = cookie[i].split("=");
    if (key_value[0]=='app' && key_value[1]=='true') {
      const head = document.head;
      head.insertAdjacentHTML('beforeend', '<link href="//cdn.shopify.com/s/files/1/0660/0160/0770/t/2/assets/rax-for-app.css?v=6" rel="stylesheet" type="text/css" media="all">');
    }
  }
}